import { rootApi } from '../rootApi';
import { baseQueryWithReauth } from '../base';

export const documentContentApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        uploadDocumentContent: builder.mutation({
            query: ({ documentId, file, comment }) => {
                const formData = new FormData();
                formData.append('DocumentId', documentId);
                formData.append('File', file);
                if (comment) {
                    formData.append('Comment', comment);
                }
                return {
                    url: 'v1/DocumentContent/upload',
                    method: 'POST',
                    body: formData,
                };
            },
            invalidatesTags: ['DocumentContent'],
        }),
        downloadDocument: builder.query({
            queryFn: async (id, { getState }) => {
                try {
                    // baseQueryWithReauth ile request yap ama custom handling ile
                    const result = await baseQueryWithReauth(
                        {
                            url: `v1/DocumentContent/${id}/download`,
                            method: 'GET',
                            responseHandler: async (response) => {
                                if (!response.ok) {
                                    throw new Error(`HTTP error! status: ${response.status}`);
                                }
                                return await response.blob();
                            }
                        },
                        { getState },
                        {}
                    );
                    if (result.error) {
                        return { error: result.error };
                    }
                    return { data: result.data };
                } catch (error) {
                    return { error: { status: 'FETCH_ERROR', error: error.message } };
                }
            },
            providesTags: (result, error, id) => [{ type: 'DocumentContent', id }],
        }),
        getDownloadUrl: builder.query({
            query: ({ id, expirationMinutes }) => {
                let url = `v1/DocumentContent/${id}/url`;
                if (expirationMinutes) {
                    url += `?expirationMinutes=${expirationMinutes}`;
                }
                return {
                    url,
                    method: 'GET',
                };
            },
        }),
        getPreviewUrl: builder.query({
            query: ({ id, expirationMinutes }) => {
                let url = `v1/DocumentContent/${id}/preview`;
                if (expirationMinutes) {
                    url += `?expirationMinutes=${expirationMinutes}`;
                }
                return {
                    url,
                    method: 'GET',
                };
            },
        }),
        getDownloadUrlByKey: builder.query({
            query: ({ fileKey, expirationMinutes }) => {
                let url = `v1/DocumentContent/GetDownloadUrlByKey?fileKey=${fileKey}`;
                if (expirationMinutes) {
                    url += `&expirationMinutes=${expirationMinutes}`;
                }
                return {
                    url,
                    method: 'GET',
                };
            },
        }),
        downloadByKey: builder.query({
            queryFn: async (fileKey, { getState }) => {
                try {
                    const result = await baseQueryWithReauth(
                        {
                            url: `v1/DocumentContent/DownloadByKey?fileKey=${fileKey}`,
                            method: 'GET',
                            responseHandler: async (response) => {
                                if (!response.ok) {
                                    throw new Error(`HTTP error! status: ${response.status}`);
                                }
                                return await response.blob();
                            }
                        },
                        { getState },
                        {}
                    );
                    if (result.error) {
                        return { error: result.error };
                    }
                    return { data: result.data };
                } catch (error) {
                    return { error: { status: 'FETCH_ERROR', error: error.message } };
                }
            },
        }),

        downloadDocumentByKey: builder.query({
            queryFn: async (fileKey, { getState }) => {
                try {
                    const result = await baseQueryWithReauth(
                        {
                            url: `v1/DocumentContent/downloadasjsonbykey?fileKey=${fileKey}`,
                            method: 'GET',
                            responseHandler: async (response) => {
                                if (!response.ok) {
                                    throw new Error(`HTTP error! status: ${response.status}`);
                                }
                                return await response.json();
                            }
                        },
                        { getState },
                        {}
                    );

                    // result.data doğrudan blob'u içerir
                    if (result.error) {
                        return { error: result.error };
                    }

                    return { data: result.data }; // Burada data zaten blob'dur
                } catch (error) {
                    console.error("Download by key error:", error);
                    return { error: { status: 'FETCH_ERROR', error: error.message } };
                }
            },
            providesTags: (result, error, fileKey) => [{ type: 'DocumentContent', id: fileKey }],
        }),
    }),


});

export const {
    useDownloadDocumentQuery,
    useGetDownloadUrlQuery,
    useGetPreviewUrlQuery,
    useGetDownloadUrlByKeyQuery,
    useDownloadByKeyQuery,
    useLazyDownloadDocumentQuery,
    useLazyGetDownloadUrlQuery,
    useLazyGetPreviewUrlQuery,
    useLazyGetDownloadUrlByKeyQuery,
    useLazyDownloadByKeyQuery,
    useUploadDocumentContentMutation,
    useDownloadDocumentByKeyQuery,
    useLazyDownloadDocumentByKeyQuery,
} = documentContentApi;